import { render, staticRenderFns } from "./rubrics_table.vue?vue&type=template&id=4e03f2ba&scoped=true&"
import script from "./rubrics_table.vue?vue&type=script&lang=js&"
export * from "./rubrics_table.vue?vue&type=script&lang=js&"
import style0 from "./rubrics_table.vue?vue&type=style&index=0&id=4e03f2ba&prod&lang=scss&scoped=true&"
import style1 from "./rubrics_table.vue?vue&type=style&index=1&id=4e03f2ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e03f2ba",
  null
  
)

export default component.exports